import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DialogActions from "@mui/material/DialogActions";

import ModalBasicLayout from "../ModalBasicLayout";
import Loader from "../../Loaders/Loader";
import Gallery from "../../Gallery/Gallery";
import LinearLoaderWithTime from "../../Loaders/LinearLoaderWithTime";
import Button from "../../Buttons/Button";
import {
  BUTTON_ADD_SELECTED_CONTENT,
  MODAL_GALLERY_ARIA_LABEL,
  PROCESSING_MEDIA_TO_USE,
  SAVING_MEDIA,
} from "../../../i18n/keysTranslations";

const MODAL_GALLERY_TITLE_SX = {
  justifyContent: "space-between",
  width: "100%",
  pl: 9,
  pb: 2,
};

const ModalGalleryFromUrlLayout = ({
  t,
  modalOpen,
  onCloseModal,
  titleKey,
  isLoading,
  loadingMessageKey,
  error,
  totalTopOffsetPx,
  emptyContentKey,
  galleryDisplayData,
  galleryProps,
  hasSelection,
  isUploading,
  onConfirmSelection,
  showUploadingFooter = false,
  uploadingFooterLabels = [],
  emptyContentKeyOverride = null,
}) => {
  const hasModalTitle = Boolean(titleKey);
  const sxTitle = hasModalTitle ? MODAL_GALLERY_TITLE_SX : undefined;

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      title={hasModalTitle ? t(titleKey) : undefined}
      titleContent={!hasModalTitle}
      sxTitle={sxTitle}
      fullWidth={true}
      fullScreen
      scroll="paper"
      aria-label={t(MODAL_GALLERY_ARIA_LABEL)}
      sxContent={{
        p: 0,
        pl: 3,
        pb: 2,
        mt: 1,
        overflowX: "hidden",
        "::-webkit-scrollbar": {
          width: 0,
          height: 0,
          background: "transparent",
        },
      }}
    >
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            px: 4,
            py: 6,
            minHeight: `calc(100vh - ${totalTopOffsetPx + 120}px)`,
          }}
        >
          <Loader size={70} hasMessage={true} message={t(loadingMessageKey)} />
        </Box>
      ) : null}

      {!isLoading && !!error ? (
        <Box
          sx={{
            height: `calc(100% - ${totalTopOffsetPx}px)`,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ml: "-12px",
            px: 2,
          }}
        >
          <Typography variant="body1" align="center" color="error.main">
            {error}
          </Typography>
        </Box>
      ) : null}

      {!isLoading && !error && galleryDisplayData.length > 0 ? (
        <Gallery {...galleryProps} />
      ) : null}

      {!isLoading && !error && galleryDisplayData.length === 0 ? (
        <Box
          sx={{
            height: `calc(100% - ${totalTopOffsetPx}px)`,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ml: "-12px",
          }}
        >
          <Typography variant="h4" align="center">
            {t(emptyContentKeyOverride || emptyContentKey)}
          </Typography>
        </Box>
      ) : null}

      {hasSelection || (showUploadingFooter && isUploading) ? (
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: isUploading ? "#FFF" : "transparent",
            position: "sticky",
            bottom: 0,
            zIndex: 2,
            mt: 2,
            mb: 2,
            py: 1,
          }}
        >
          {isUploading && showUploadingFooter ? (
            <LinearLoaderWithTime
              labels={
                uploadingFooterLabels.length > 0
                  ? uploadingFooterLabels.map((labelKey) => t(labelKey))
                  : [t(PROCESSING_MEDIA_TO_USE), t(SAVING_MEDIA)]
              }
              time={30 * 1000}
            />
          ) : (
            <Button
              color="primary"
              disabled={isUploading}
              onClick={(event) => {
                event?.preventDefault();
                event?.stopPropagation();
                onConfirmSelection();
              }}
            >
              {t(BUTTON_ADD_SELECTED_CONTENT)}
            </Button>
          )}
        </DialogActions>
      ) : null}
    </ModalBasicLayout>
  );
};

export default ModalGalleryFromUrlLayout;
